import { Component, OnInit } from '@angular/core';
import { IOrganizationDetails } from 'src/app/common/common-model';
import { GlobalService } from 'src/app/common/global.service';
import { INav, navList } from './home.model';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  navListDetails: INav[] = navList;

  constructor(private commonService: GlobalService) {}

  ngOnInit(): void {
    if (sessionStorage.getItem('organizationList') === null) {
      this.commonService.getSchemeWiseDetails().subscribe(() => {});
    }
  }
}
